// extracted by mini-css-extract-plugin
var _1 = "mdsgw4vd";
var _2 = "dSDSaXKC";
var _3 = "QrT4BWMv";
var _4 = "nyQMnjIf";
export { _1 as "box", _2 as "checkbox", _3 as "checked", _4 as "input" }
